import React, {
  MutableRefObject,
  useCallback,
  useState,
  useContext,
} from 'react';
import { PaddedGrid } from 'spw-components/growth-calculator/styles';
import {
  IProjectColors,
  IProjectSpaceTypeCategory,
} from 'spw-redux/modules/projects/types';
import { IProjectSpaceType } from 'spw-redux/modules/space_types/types';
import { ProgramSummaryContext } from 'spw-programming-projects/program-summary/program-summary-context';
import { WidenedGrid } from '../macro-single-page-summary/styles';
import { CategoryUsfMix } from '../cards/category-usf-mix';
import { CategorySeatTypeMix } from '../cards/category-seat-type-mix';
import { PlainWorksheet } from '../../../../models/Worksheet';

export const CategorySummaryRow = ({
  reference,
  projectSpaceTypeCategory,
  projectColors,
  worksheet,
  shouldShowChildrenRowsForDownload,
  isRenderingForExport,
  onClickSpaceIcon,
  projectSpaceTypes,
  viewOnly,
  clientFacingNamesAreVisible,
}: {
  reference?: MutableRefObject<HTMLDivElement>;
  projectSpaceTypeCategory: IProjectSpaceTypeCategory;
  projectColors: IProjectColors;
  worksheet: PlainWorksheet;
  shouldShowChildrenRowsForDownload: boolean;
  isRenderingForExport?: boolean;
  onClickSpaceIcon?: (e: Element) => void;
  projectSpaceTypes: { [id: number]: IProjectSpaceType };
  viewOnly: boolean;
  clientFacingNamesAreVisible?: boolean;
}) => {
  const [open, setOpen] = useState(shouldShowChildrenRowsForDownload);

  const toggleOpen = useCallback(() => {
    setOpen((prev) => !prev);
  }, [setOpen]);

  const { visibleCards } = useContext(ProgramSummaryContext);

  const categoryUsfAndRatios =
    visibleCards?.categoryUsfAndSeatMix?.[
      projectSpaceTypeCategory.defaultSpaceTypeCategory.category
    ];

  return (
    <>
      {(!isRenderingForExport ||
        categoryUsfAndRatios?.usfMixAndRatios ||
        categoryUsfAndRatios?.usfMix ||
        categoryUsfAndRatios?.ratios) && (
        <WidenedGrid container ref={reference} $scrollMarginTop={110}>
          {(!isRenderingForExport ||
            categoryUsfAndRatios?.usfMixAndRatios ||
            categoryUsfAndRatios?.usfMix) && (
            <PaddedGrid
              item
              xs={6}
              style={{
                paddingLeft: '16px',
                paddingRight: '8px',
                paddingTop: '8px',
              }}
            >
              <CategoryUsfMix
                viewOnly={viewOnly}
                projectSpaceTypes={projectSpaceTypes}
                onClickSpaceIcon={onClickSpaceIcon}
                projectSpaceTypeCategory={projectSpaceTypeCategory}
                worksheet={worksheet}
                projectColors={projectColors}
                open={open}
                setOpen={toggleOpen}
                isRenderingForExport={isRenderingForExport}
                clientFacingNamesAreVisible={clientFacingNamesAreVisible}
              />
            </PaddedGrid>
          )}

          {(!isRenderingForExport ||
            categoryUsfAndRatios?.usfMixAndRatios ||
            categoryUsfAndRatios?.ratios) && (
            <PaddedGrid
              item
              xs={6}
              style={{
                paddingLeft: categoryUsfAndRatios?.ratios ? '16px' : '8px',
                paddingRight: '16px',
                paddingTop: '8px',
              }}
            >
              <CategorySeatTypeMix
                viewOnly={viewOnly}
                projectSpaceTypes={projectSpaceTypes}
                onClickSpaceIcon={onClickSpaceIcon}
                projectSpaceTypeCategory={projectSpaceTypeCategory}
                worksheet={worksheet}
                open={open}
                projectColors={projectColors}
                isRenderingForExport={isRenderingForExport}
                clientFacingNamesAreVisible={clientFacingNamesAreVisible}
              />
            </PaddedGrid>
          )}
        </WidenedGrid>
      )}
    </>
  );
};
